import { render } from "./DeletedUsers.vue?vue&type=template&id=70acb431"
import script from "./DeletedUsers.vue?vue&type=script&lang=js"
export * from "./DeletedUsers.vue?vue&type=script&lang=js"

import "./DeletedUsers.vue?vue&type=style&index=0&id=70acb431&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__